// extracted by mini-css-extract-plugin
module.exports = {"waldorfContainer":"style_waldorfContainer__0p16c"};